import { LogoImg, NameText, Wrapper } from './BrandHeader.styles';
import type { BrandHeaderProps } from './BrandHeader.types';

export function BrandHeader({ propertyName, logoUrl }: BrandHeaderProps) {
  return (
    <Wrapper>
      {logoUrl ? <LogoImg src={logoUrl} alt={propertyName} /> : <NameText>{propertyName}</NameText>}
    </Wrapper>
  );
}
